module.exports = __webpack_public_path__ + "img/newcastle-united-logo-icon.9b667eb1.png";